<script>
import axios from "axios";
import _ from "lodash";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "IpEdit",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  props: {
    itemId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      apiUrl: 'api/manager/ip/',
      loadDCsUrl: '/api/manager/dc/list?sort=Id',
      loadServersUrl: '/api/manager/server/list',
      item: {},
      DcList: [],
      ServerLists: [],
    }
  },
  methods: {
    submitForm() {
      let loader = this.$loading.show();
      axios.patch(this.apiUrl, {...this.item}, this.authRespConf())
          .then((res) => {
            loader.hide();
            this.$bvToast.toast(res.data.message, {
              title: `Successfully request`,
              noAutoHide: true,
              variant: 'success',
              appendToast: true
            })
            this.modalClosed()
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          });
    },
    getServerList() {
      let loader = this.$loading.show();
      axios.post(this.loadServersUrl, [],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.ServerLists = _.map(res.data.data, (item) => {
                return {
                  label: item.Name,
                  value: item.Id
                }
              })
            }
          })
    },
    getDcList() {
      let loader = this.$loading.show();
      axios.post(this.loadDCsUrl, [],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.DcList = _.map(res.data.data, (item) => {
                return {
                  label: item.Name,
                  value: item.Id
                }
              })
            }
          })
    },
    getIpData() {
      let loader = this.$loading.show();
      axios.get(` api/manager/ip/${this.itemId}`,
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.item = res.data.data
            }
          })
    },
    modalOpened() {
      this.getDcList()
      this.getServerList()
      this.getIpData()
    },
    modalClosed() {
      this.item = {}
      this.$modal.hide('IpEdit');
    }
  }
}
</script>

<template>
  <div class="wrapper">
    <modal
        name="IpEdit"
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        :width="850"
        :min-width="425"
        :min-height="360"
        :height="560"
        :scrollable="true"
        @closed="modalClosed"
        @opened="modalOpened"
        class="modalBox"
        :style="{'--selectHeight': '120px'}"
    >
      <div class="window-header">
        Edit IP: {{ item.Address }} State: <span v-if="item.State === 'OK'" style="all: initial;vertical-align: sub;">🟢</span><span
          v-else-if="item.State === 'NO PING'" style="all: initial;vertical-align: sub;">🔴</span><span
          v-else-if="item.State === '' || item.State === null" style="all: initial;vertical-align: sub;">0️⃣️</span>
        <a href="javascript:void(0)" class="close-modal pull-right" @click="modalClosed()"><i
            class="fa fa-times"></i></a>
      </div>
      <div class="modal-body">
        <div class="page-modal" style="background: white;">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 col-form-label">IP</label>
              <div class="col-sm-10">
                <input disabled class="form-control" :value="item.Address"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 col-form-label">Datacenter <span class="text-danger">*</span></label>
              <div class="col-sm-10">
                <v-select
                    :options="DcList"
                    label="label"
                    v-model="item.DcId"
                    :reduce="server => server.value"
                    placeholder="Select Datacenter.."
                    required
                    inputId="Dc"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 col-form-label">Mask</label>
              <div class="col-sm-10">
                <input class="form-control" v-model="item.Mask" placeholder="N/A"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 col-form-label">Server</label>
              <div class="col-sm-10">
                <v-select
                    :options="ServerLists"
                    label="label"
                    v-model="item.ServerId"
                    :reduce="server => server.value"
                    placeholder="Select Server.."
                    required
                    inputId="Server"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 col-form-label">Comment</label>
              <div class="col-sm-10">
                <input class="form-control" v-model="item.Comment" placeholder="N/A"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 col-form-label">MAC</label>
              <div class="col-sm-10">
                <input class="form-control" v-model="item.Mac" placeholder="N/A"/>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="submitForm()" class="btn btn-primary">Update</button>
        <button
            class="btn btn-default"
            href="javascript:void(0);"
            v-on:click="modalClosed()"
            type="button"
        >
          <span>Cancel</span>
        </button>
      </div>
    </modal>
  </div>
</template>

<style scoped>

</style>